<p-toast [baseZIndex]="10000"></p-toast>

@if (isLoading) {
  <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
}
<div [hidden]="isLoading">
  <div class="d-flex justify-content-center scroll min-height">
    <div class="row col-10">
      <p-fieldset legend="{{ 'Administration.Manual Cleanup.Title' | translate }}">
        <app-administration-manual-cleanup-form
          [isLoading]="isLoading"
          [isLoadingPeriods]="isLoadingPeriods"
          [manualCleanup]="manualCleanup"
          (showToastMethod)="showToast($event)"
          (isLoadingMethod)="isLoadingMethod($event)"
          (isLoadingPeriodsMethod)="isLoadingPeriodsMethod($event)"
        > </app-administration-manual-cleanup-form>

        <div class="my-5 mr-8 d-flex justify-content-end">
          <p-button id="saveManualCleanupProcess" type="button" severity="primary"
            label="{{ 'Common.Execute' | translate }}" (click)="executeManualCleanupProcess()"
            [disabled]="manualCleanupComponent?.manualCleanupForm?.invalid || manualCleanup.periodFrom > manualCleanup.periodTo"
          >
          </p-button>
        </div>
      </p-fieldset>
    </div>
  </div>
</div>
